<!-- Barra superior (oculta en zona participantes / Entra ID) -->
<div *ngIf="!esZonaParticipantes" class="custom-toolbar" style="margin-right:auto !important; display:flex; align-items:center;">
  

  <div *ngIf="loginDisplay" >
    <button
      pButton
      type="button"
      icon="pi pi-bars"
      class="p-button-text p-button-plain"
      (click)="sidebarVisible = true"
      style="margin-left:0 !important;">
    </button>


    <!-- Sidebar -->
    <p-sidebar
      [(visible)]="sidebarVisible"
      [baseZIndex]="1000"
      [position]="'left'"
      (onClick)="sidebarVisible = false"
      styleClass="custom-sidebar">

      <div class="sidebar-header">
        <i class="pi pi-user"></i>
        
        <span class="user-name">{{ obtenerusuario().Nombre }}</span>
      </div>

      <p-panelMenu  [model]="items" styleClass="w-full mt-3"></p-panelMenu >
    </p-sidebar>
  </div>
  <span class="logo-text" style="margin-left:0 !important;">{{ title }}</span>
</div>

<!-- Contenido principal -->
<div class="container" [class.participantes-full]="esZonaParticipantes">
  <p-toast></p-toast>
  <router-outlet *ngIf="!isIframe"></router-outlet>
</div>
